import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/abonnement')({
  /**
   * La facturation engage le cabinet : réservée à ses administrateurs. Le lien
   * est masqué pour les comptes secondaires, ce garde ferme l'accès par URL
   * directe. Posé ici plutôt que sur chaque sous-page : il protège aussi
   * `/abonnement/paiements`.
   */
  beforeLoad: ({ context }) => {
    if (context.me.user.role !== 'admin') throw redirect({ to: '/' });
  },
  component: () => <Outlet />,
});
